// helper
import Util from "@/helper/Utility.js";
import { ErrorModalController } from "@/components/Modal/Generic/ErrorModal/ErrorModalController"

export default function useErrorModal (modalStore) {
    const modalController = modalStore.methods.getModalController();
    if (modalController.errorModal == null) {
        modalController.setErrorModal(new ErrorModalController())
    }

    const errorModal = modalController.errorModal

    const showErrorModal = function (msg, opts = {}) {
        errorModal
            .clearModal()
            .setMsg(msg)
            .show(opts)
    };

    const showApiErrorModal = function (error, opts = {}) {
        let alertMsg = '';
        if (error.code) {
            switch (error.code) {
                case 409:
                case 401:
                    alertMsg = error.message;
                    break;
                case 412:
                    alertMsg = "Token invalid";
                    break;
                default:
                    alertMsg = error.message;
                    break;
            }
        } else {
            // title = "Network Error"
            alertMsg = "Please try again later";
        }

        errorModal
            .clearModal()
            .setMsg(alertMsg)
            .show(opts);
    };

    const hideErrorModal = function () {
        errorModal
            .clearModal()
            .hide();
    };

    const onClickErrorModalClose = function (callback) {
        if (!Util.isFunction(callback)) return;

        errorModal
            .onClose(() => {
                callback();
            });
    };

    return {
        showErrorModal,
        showApiErrorModal,
        hideErrorModal,
        onClickErrorModalClose
    }
}
